export default __webpack_public_path__ + "static/media/bgHeader.8a516c23.png";